import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  fr: {
    // Navigation
    nav: {
      home: 'Accueil',
      audits: 'Audits',
      services: 'Services',
      about: 'À propos',
      testimonials: 'Témoignages',
      contact: 'Contact',
      bookCall: 'Réserver un appel'
    },
    // Hero
    hero: {
      tagline: 'your business partner',
      title: 'Stratégie & Performance',
      subtitle: 'Cabinet de consulting expert en stratégie et performance d\'entreprise. Nous accompagnons les dirigeants ambitieux à structurer, accélérer et pérenniser leur croissance.',
      cta: 'Découvrir nos services',
      ctaSecondary: 'Prendre rendez-vous'
    },
    // Values
    values: {
      title: 'Nos Valeurs',
      subtitle: 'Les piliers de notre accompagnement',
      entrepreneurship: {
        title: 'Entrepreneuriat',
        desc: 'Nous valorisons l\'esprit entrepreneurial et accompagnons les visionnaires dans la réalisation de leurs ambitions.'
      },
      excellence: {
        title: 'Excellence',
        desc: 'Nous nous engageons à fournir un service d\'excellence avec des résultats mesurables et durables.'
      },
      connection: {
        title: 'Connexion Mondiale',
        desc: 'Nous connectons les entrepreneurs et décideurs à travers la France, l\'Europe et l\'Afrique.'
      }
    },
    // Services
    services: {
      title: 'Nos Offres',
      subtitle: 'Des solutions adaptées à vos ambitions',
      from: 'À partir de',
      bronze: {
        name: 'Pack Bronze',
        subtitle: 'BICENTER BUSINESS PRESS ON',
        price: '4 000€ - 7 000€',
        desc: 'Service d\'entrée idéal pour les entreprises souhaitant optimiser leurs opérations.',
        features: ['Audit initial des processus', 'Recommandations stratégiques', 'Plan d\'action 3 mois', 'Support email']
      },
      diamond: {
        name: 'Pack Diamant',
        subtitle: 'BICENTER BUSINESS GROW',
        price: '8 000€ - 12 000€',
        desc: 'Solutions stratégiques et accompagnement personnalisé pour la croissance.',
        features: ['Diagnostic stratégique 360°', 'Accompagnement personnalisé', 'Sessions mensuelles', 'Support prioritaire']
      },
      gold: {
        name: 'Pack Or',
        subtitle: 'BICENTER BUSINESS PERFORM PREMIUM',
        price: '6 000€ - 15 000€',
        desc: 'Le pack premium pour l\'excellence avec suivi global et management de transfert.',
        features: ['Analyses approfondies', 'Suivi mensuel global', 'Management de transfert', 'Accès réseau VIP']
      },
      strategic: {
        name: 'Cercles Stratégiques',
        subtitle: 'ABONNEMENT PREMIUM',
        price: '750€/mois',
        desc: 'Accompagnement continu pour les décideurs exigeants avec accès au réseau privé.',
        features: ['Pilotage mensuel', 'Sessions stratégiques', 'Support décisionnel', 'Réseau décideurs & investisseurs']
      },
      cta: 'En savoir plus'
    },
    // Specific Services
    specificServices: {
      title: 'Services Spécifiques',
      diagnostic: {
        title: 'Diagnostic Stratégique 360°',
        price: '1 800€',
        result: 'Vision claire, priorités structurées, plan d\'action 12 mois'
      },
      branding: {
        title: 'Positionnement & Branding Dirigeant',
        price: '2 000€',
        result: 'Stratégie de positionnement, message d\'impact, plan d\'influence 6 mois'
      },
      brand: {
        title: 'Stratégie & Développement de Marque',
        price: '2 500€',
        result: 'Plateforme de marque, identité stratégique, plan de développement'
      },
      business: {
        title: 'Business Plan Stratégique 3 ans',
        price: '2 500€',
        result: 'Analyse marché, modèle économique, projection financière'
      }
    },
    // About
    about: {
      title: 'À Propos',
      founderWord: 'Mot de la Fondatrice',
      founderName: 'Laurianne NGOUNOU',
      founderTitle: 'Consultante experte en stratégie et performance',
      founderCredentials: 'Diplômée d\'un Master 2 en Management et Business développement, experte en closing et entreprenariat',
      founderQuote: 'Notre mission est de permettre aux entrepreneurs, décideurs et investisseurs ambitieux de saisir les opportunités business et d\'accompagner les entreprises vers l\'excellence.',
      bio: 'Le cabinet Bicenter Consulting, spécialisé en stratégie et performance d\'entreprises accompagne des TPE, PME, start-up et grandes entreprises en France, en Europe et en Afrique. Notre approche hybride intègre les nouvelles technologies et l\'IA générative pour optimiser vos processus et leviers de performance.',
      expertise: 'Expertise',
      expertiseItems: ['Stratégie d\'entreprises et institutions', 'Performance opérationnelle', 'Montage, structuration et transformation'],
      markets: 'Marchés',
      marketItems: ['France', 'Europe', 'Afrique']
    },
    // Testimonials
    testimonials: {
      title: 'Témoignages',
      subtitle: 'Ils nous font confiance',
      items: [
        {
          name: 'Marie Dupont',
          role: 'CEO, TechStart Paris',
          text: 'Bicenter Consulting a transformé notre vision stratégique. En 6 mois, nous avons doublé notre chiffre d\'affaires grâce à leur accompagnement personnalisé.'
        },
        {
          name: 'Amadou Diallo',
          role: 'Fondateur, Diallo Industries',
          text: 'L\'expertise de Laurianne en matière de développement sur les marchés africains et européens a été déterminante pour notre expansion internationale.'
        },
        {
          name: 'Sophie Martin',
          role: 'Directrice Générale, InnovateCorp',
          text: 'Le diagnostic stratégique 360° nous a permis d\'identifier nos leviers de croissance et de structurer notre développement sur 3 ans.'
        }
      ]
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Échangeons sur votre projet',
      form: {
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone',
        company: 'Entreprise',
        message: 'Votre message',
        submit: 'Envoyer',
        success: 'Message envoyé avec succès !',
        error: 'Une erreur est survenue. Veuillez réessayer.'
      },
      booking: {
        title: 'Réserver un rendez-vous',
        selectDate: 'Sélectionnez une date',
        selectTime: 'Choisissez un créneau',
        service: 'Service souhaité',
        notes: 'Notes (optionnel)',
        submit: 'Confirmer le rendez-vous',
        success: 'Rendez-vous confirmé !',
        error: 'Une erreur est survenue. Veuillez réessayer.'
      },
      info: {
        address: '60 rue François 1er, 75008 Paris, France',
        email: 'cabinet@bicenter-consulting.com',
        website: 'www.bicenter-consulting.com'
      }
    },
    // Footer
    footer: {
      tagline: 'your business partner',
      description: 'Cabinet de consulting en stratégie et performance d\'entreprise. Expertise en France, Europe et Afrique.',
      quickLinks: 'Liens rapides',
      services: 'Services',
      contact: 'Contact',
      join: 'Rejoignez le mouvement',
      joinDesc: 'Entrepreneurs, décideurs et investisseurs',
      joinCta: 'Découvrir Bicenter Connect',
      rights: 'Tous droits réservés',
      consulting100: 'Consulting 100% à distance'
    },
    // Common
    common: {
      learnMore: 'En savoir plus',
      contactUs: 'Nous contacter',
      bookNow: 'Réserver maintenant'
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      audits: 'Audits',
      services: 'Services',
      about: 'About',
      testimonials: 'Testimonials',
      contact: 'Contact',
      bookCall: 'Book a call'
    },
    // Hero
    hero: {
      tagline: 'your business partner',
      title: 'Strategy & Performance',
      subtitle: 'Expert consulting firm in business strategy and performance. We help ambitious leaders structure, accelerate and sustain their growth.',
      cta: 'Discover our services',
      ctaSecondary: 'Book a meeting'
    },
    // Values
    values: {
      title: 'Our Values',
      subtitle: 'The pillars of our support',
      entrepreneurship: {
        title: 'Entrepreneurship',
        desc: 'We value the entrepreneurial spirit and support visionaries in achieving their ambitions.'
      },
      excellence: {
        title: 'Excellence',
        desc: 'We are committed to providing excellent service with measurable and sustainable results.'
      },
      connection: {
        title: 'Global Connection',
        desc: 'We connect entrepreneurs and decision-makers across France, Europe and Africa.'
      }
    },
    // Services
    services: {
      title: 'Our Packages',
      subtitle: 'Solutions tailored to your ambitions',
      from: 'Starting from',
      bronze: {
        name: 'Bronze Pack',
        subtitle: 'BICENTER BUSINESS PRESS ON',
        price: '€4,000 - €7,000',
        desc: 'Entry-level service ideal for businesses looking to optimize their operations.',
        features: ['Initial process audit', 'Strategic recommendations', '3-month action plan', 'Email support']
      },
      diamond: {
        name: 'Diamond Pack',
        subtitle: 'BICENTER BUSINESS GROW',
        price: '€8,000 - €12,000',
        desc: 'Strategic solutions and personalized support for growth.',
        features: ['360° strategic diagnosis', 'Personalized support', 'Monthly sessions', 'Priority support']
      },
      gold: {
        name: 'Gold Pack',
        subtitle: 'BICENTER BUSINESS PERFORM PREMIUM',
        price: '€6,000 - €15,000',
        desc: 'Premium pack for excellence with global monitoring and transfer management.',
        features: ['In-depth analysis', 'Global monthly monitoring', 'Transfer management', 'VIP network access']
      },
      strategic: {
        name: 'Strategic Circles',
        subtitle: 'PREMIUM SUBSCRIPTION',
        price: '€750/month',
        desc: 'Continuous support for demanding decision-makers with private network access.',
        features: ['Monthly steering', 'Strategic sessions', 'Decision support', 'Decision-makers & investors network']
      },
      cta: 'Learn more'
    },
    // Specific Services
    specificServices: {
      title: 'Specific Services',
      diagnostic: {
        title: '360° Strategic Diagnosis',
        price: '€1,800',
        result: 'Clear vision, structured priorities, 12-month action plan'
      },
      branding: {
        title: 'Executive Positioning & Branding',
        price: '€2,000',
        result: 'Positioning strategy, impact message, 6-month influence plan'
      },
      brand: {
        title: 'Brand Strategy & Development',
        price: '€2,500',
        result: 'Brand platform, strategic identity, development plan'
      },
      business: {
        title: '3-Year Strategic Business Plan',
        price: '€2,500',
        result: 'Market analysis, business model, financial projection'
      }
    },
    // About
    about: {
      title: 'About',
      founderWord: 'Founder\'s Word',
      founderName: 'Laurianne NGOUNOU',
      founderTitle: 'Expert consultant in strategy and performance',
      founderCredentials: 'Master\'s degree in Management and Business Development, expert in closing and entrepreneurship',
      founderQuote: 'Our mission is to enable ambitious entrepreneurs, decision-makers and investors to seize business opportunities and guide companies towards excellence.',
      bio: 'Bicenter Consulting, specialized in business strategy and performance, supports VSEs, SMEs, start-ups and large companies in France, Europe and Africa. Our hybrid approach integrates new technologies and generative AI to optimize your processes and performance drivers.',
      expertise: 'Expertise',
      expertiseItems: ['Corporate & institutional strategy', 'Operational performance', 'Structuring & transformation'],
      markets: 'Markets',
      marketItems: ['France', 'Europe', 'Africa']
    },
    // Testimonials
    testimonials: {
      title: 'Testimonials',
      subtitle: 'They trust us',
      items: [
        {
          name: 'Marie Dupont',
          role: 'CEO, TechStart Paris',
          text: 'Bicenter Consulting transformed our strategic vision. In 6 months, we doubled our revenue thanks to their personalized support.'
        },
        {
          name: 'Amadou Diallo',
          role: 'Founder, Diallo Industries',
          text: 'Laurianne\'s expertise in developing African and European markets was decisive for our international expansion.'
        },
        {
          name: 'Sophie Martin',
          role: 'Managing Director, InnovateCorp',
          text: 'The 360° strategic diagnosis allowed us to identify our growth drivers and structure our development over 3 years.'
        }
      ]
    },
    // Contact
    contact: {
      title: 'Contact',
      subtitle: 'Let\'s discuss your project',
      form: {
        name: 'Full name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company',
        message: 'Your message',
        submit: 'Send',
        success: 'Message sent successfully!',
        error: 'An error occurred. Please try again.'
      },
      booking: {
        title: 'Book an appointment',
        selectDate: 'Select a date',
        selectTime: 'Choose a time slot',
        service: 'Desired service',
        notes: 'Notes (optional)',
        submit: 'Confirm appointment',
        success: 'Appointment confirmed!',
        error: 'An error occurred. Please try again.'
      },
      info: {
        address: '60 rue François 1er, 75008 Paris, France',
        email: 'cabinet@bicenter-consulting.com',
        website: 'www.bicenter-consulting.com'
      }
    },
    // Footer
    footer: {
      tagline: 'your business partner',
      description: 'Business strategy and performance consulting firm. Expertise in France, Europe and Africa.',
      quickLinks: 'Quick links',
      services: 'Services',
      contact: 'Contact',
      join: 'Join the movement',
      joinDesc: 'Entrepreneurs, decision-makers and investors',
      joinCta: 'Discover Bicenter Connect',
      rights: 'All rights reserved',
      consulting100: '100% remote consulting'
    },
    // Common
    common: {
      learnMore: 'Learn more',
      contactUs: 'Contact us',
      bookNow: 'Book now'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');

  const toggleLanguage = useCallback(() => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  }, []);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
